<template>
  <div class="main">
    <van-image
      fit="cover"
      src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/5.png"
      class="banner"
    />
    <div class="introduce">
      <div class="title">产品介绍</div>
      <div class="content">
        <div>
          <img
            src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/10.png"
            alt=""
          />
          <img
            src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/11.jpg?x-oss-process=image/resize,m_fill,h_290,w_740"
            alt=""
          />
        </div>
        <div class="desc">
          灵点以云端VR交互课件、3D模型、全景视频、全景图片等教学资源为基础，为大客户提供资源授权管理以及教师/学生-学校-区级资源三级共享服务，以XR教学数据、基础行为数据、虚拟实验评测数据、运营数据，域名定制、平台模块与样式定制、私有云部署为基本架构，满足不同客户的定制化需求。
        </div>
      </div>
    </div>
    <!-- 平台服务优势 -->
    <Constitute :title="'平台服务优势'" :constitute="constitute"></Constitute>
    <!-- 主要功能模块 -->
    <Module title="功能模块" :list="plan"></Module>
    <!-- 客户案例 -->
    <Eg :list="egList"></Eg>
  </div>
</template>
<script>
import Eg from '@/component/example';
import Constitute from '@/component/constitute';
import Module from '@/component/module';

export default {
  components: {
    Eg,
    Constitute,
    Module
  },
  data() {
    return {
      list: [1, 2, 3, 4],
      plan: [
        {
          title: '学校管理',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/6.png'
        },
        {
          title: '代理商管理',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/7.png'
        },
        {
          title: '资源管理',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/8.png'
        },
        {
          title: '数据分析',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/9.png'
        }
      ],
      constitute: [
        {
          title: '多级代理管理',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/1.png',
          desc:'支持多级跨地域分级代理商管理自有客户和资源授权，丰富的数据呈现'
        },
        {
          title: '模块定制服务',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/2.png',
          desc:'可据客户需求提供个性化、专属化的定制服务，功能模块灵活拆分组合'
        },
        {
          title: '资源授权机制',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/3.png',
          desc:'资源授权继承机制，一键授权实现学校教师及其班级学生同时资源共享'
        },
        {
          title: '内容管理完善',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/4.png',
          desc:'包含VR课件、3D模型、视频、全景图片等类型的k12全学科优质资源'
        }
      ],
      egList: [
        {
          title: '北京朝阳实验小学',
          desc:
            'VR未来课堂将虚拟现实技术与实际教学知识点紧密结合，打造与实际教育教学高度集合的高仿真、沉浸式、可交互的解决方案，推展学习空间，提高学习兴趣，增强学习主动探究能力、创造力',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/eg/5.jpg'
        },
        {
          title: '北京清华大学附属中学',
          desc:
            '智慧宫是一款基于 5G 6DOF VR 模拟物、化、生实验场景，提供规范的实验内容、自由化交互， 结合学科实验设计的一套符合课程标准、考试要求的实验课程，该产品既能教学、也能考核。不仅解决了传统实验中遇到的高危操作、实验准备周期长、实验室不足等一系列问题，而且还能够进行批量考核',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/eg/6.jpg'
        },
        {
          title: '海南省南海博物馆',
          desc:
            '利用AR/VR技术手段，打破传统博物馆局限性，是大大的扩展博物馆的延伸空间，最大限度的拓展博物馆功能，满足社会大众的多层次多方位需求的有效途径。',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/eg/3.jpg'
        }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.main {
  background: #fff;
  .banner {
    width: 100%;
    height: 500px;
    display: block;
  }
  .introduce {
    padding: 1px;
    width: 1200px;
    height: 626px;
    margin: 0 auto;
    .title {
      font-size: 42px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.6);
      line-height: 63px;
      text-align: center;
      margin-top: 42px;
    }
    .content {
      margin-top: 50px;
      > div:nth-child(1) {
        display: flex;
        justify-content: space-between;
        > img:nth-child(1) {
          width: 420px;
          height: 290px;
        }
        > img:nth-child(2) {
          width: 740px;
          height: 290px;
        }
      }
      .desc {
        font-size: 24px;
        font-family: SourceHanSansCN-Light, SourceHanSansCN;
        font-weight: 300;
        color: rgba(0, 0, 0, 0.6);
        line-height: 40px;
        margin-top: 37px;
      }
    }
  }
  .support {
    width: 100%;
    height: 487px;
    background: #fff;
    padding-top: 1px;
    > div {
      width: 1200px;
      margin: 0 auto;
      background: #9aa4b9;
      height: 422px;
      margin-top: 120px;
      position: relative;
      padding-left: 546px;
      box-sizing: border-box;
      padding-top: 1px;
      .title {
        font-size: 36px;
        font-weight: bold;
        color: #ffffff;
        line-height: 1;
        margin-top: 84px;
      }
      .desc {
        width: 628px;
        font-size: 24px;
        font-weight: 400;
        color: #ffffff;
        line-height: 36px;
        margin-top: 20px;
      }
    }
  }
  .case {
    width: 100%;
    background: #fff;
    > div {
      width: 1200px;
      height: 691px;
      margin: 0 auto;
      padding-top: 1px;
      .title {
        font-size: 42px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.6);
        line-height: 1;
        text-align: center;
        margin-top: 48px;
      }
      .content {
        width: 100%;
        display: flex;
        height: 391px;
        margin-top: 49px;
        .hasImg {
          width: 33.3%;
          height: 100%;
          box-sizing: border-box;
          border-right: 1px solid #dadada;
          padding: 0 30px;
          &:nth-child(3) {
            border: none;
          }
          img {
            width: 100%;
            height: 200px;
          }
          .headline {
            margin-top: 40px;
            line-height: 1;
            font-size: 28px;
            font-weight: bold;
            color: #9fa1b4;
            display: block;
            &:nth-of-type(2) {
              margin-top: 10px;
            }
          }
          .desc {
            display: block;
            font-size: 18px;
            font-weight: 400;
            color: #9fa1b4;
            line-height: 24px;
            margin-top: 20px;
          }
        }
        .noImg {
          width: 33.3%;
          height: 100%;
          > div {
            width: 100%;
            padding: 15px;
            box-sizing: border-box;
            &:last-child {
              border-top: 1px solid #dadada;
            }
            .headline {
              font-size: 28px;
              font-weight: bold;
              color: #9fa1b4;
              line-height: 40px;
              min-height: 92px;
            }
            .desc {
              font-size: 18px;
              font-weight: 400;
              color: #9fa1b4;
              line-height: 24px;
              margin-top: 20px;
            }
          }
        }
      }
      .more {
        margin-top: 64px;
        display: flex;
        justify-content: center;
        span {
          font-size: 24px;
          color: #9fa1b4;
          line-height: 1;
        }
        img {
          width: 22px;
          height: 18px;
        }
      }
    }
  }
}
@media (max-width: 1000px) {
  .main{
    .banner {
      width: 100%;
      height: 348px;
      display: block;
    }
    .introduce{
      padding: 0 48px;
      width: 100%;
      .title{
        font-size: 44px;
        margin-top: 80px;
      }
      .content{
        margin-top: 80px;
        div:nth-child(1){
          img:nth-child(1) {
            width: 230px;
            height: 160px;
            margin-right: 12px;
          }
          img:nth-child(2) {
            width: 410px;
            height: 160px;
          }
        }
        .desc{
          margin-top: 40px;
          font-size: 28px;
          padding-bottom: 80px;
          color: #5E5E5E;
          letter-spacing: 0;
          text-align: justify;
          line-height: 40px;
          font-weight: 400;
        }
      }
    }
    .plan{
      background: #ebebeb;
    }
  }
}
</style>
